import { GetTagsRequest } from '~src/tags/GetTagsRequest';
import { ITag } from '~src/tags/ITag';

import { WebClientListResourceFetcher } from '../../httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import { IListResource } from '../../httpClient/resources/Resource';
import { ResourceQuery } from '../../httpClient/resources/ResourceQuery';

export class TagsResource implements IListResource<ITag> {
  private listFetcher = new WebClientListResourceFetcher(GetTagsRequest, result => result.tags);

  public all(): ResourceQuery<ITag> {
    return new ResourceQuery(this.listFetcher);
  }
}

export const Tags = new TagsResource();
